// 是否正式环境
export const isProd = process.env.NODE_ENV === 'production';

export const baseHost = window.apiURL;
// 请求连接前缀
export const baseUrl = isProd?`${baseHost}`:'/api'; //预生产